import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import {
    useParams,
} from "react-router-dom";

import uuid from 'react-uuid';
import ReactGA from "react-ga4";

import { useSelector, useDispatch } from "react-redux";
import {
    setNombreAction,
    setApellidoPaternoAction,
    setApellidoMaternoAction,
    setEstadoAction,
    setIdConcesionarioAction,
    setConcesionarioAction,
    setTelefonoAction,
    setCorreoAction,
    setFechaCitaAction,
    setHorarioAction,
    setModeloAutoAction,
    setYearAutoAction,
    setServicioAction,
    setComentariosAction,
    setAvisoPrivacidadAction,
    setDealersUrlsAction,
    setUuidAction,
    setListEstadosAction,
    setListConcesionariosAction,
    setListModelosAction,
    setListFechasHorariosAction,
    setCorreoContactoAction,
    setHorariosDealerOfflineAction
} from "../../../../actions/citasServicioActions";

import {
    isOnlyCharacters,
    isOnlyNumbers,
    isValidEmail,
    isValidPhone
} from "../../../../utilities/Validations";

import {
    sendMailConCita,
    sendMailSinCita,
    sendMailDealer,
    solicitarCita,
    getConcesionarios
} from "../../../../API/CitasServicioRequest";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import ReactLoading from 'react-loading';

import ROUTES from "../../../../utilities/Routes"


import dataModelos from '../../../../data/models-citas-servicio.json';
import IFrameResize from "../../../../plugins/template/IFrameRezise";
import { TratoComponent } from "../../../../components/Form/Trato";
//import audiCentersList from '../../../../data/audicenters.json';

const CitasServicio = () => {
    const { concesionaria } = useParams();
    let navigate = useNavigate();
    //console.log(concesionaria);

    const dispatch = useDispatch();
    let citasServiciosObj = useSelector((state) => state.citasServicio);
    //console.log(citasServiciosObj);

    const [validEmail, setvalidEmail] = React.useState(false);
    const [validPhone, setvalidPhone] = React.useState(false);
    const [todayDate,] = React.useState(new Date().setDate(new Date().getDate() + 3));
    const [startDate, setStartDate] = React.useState(null);
    const [filterDealers, setfilterDealers] = React.useState([]);
    const [errorFormStatus, setErrorFormStatus] = React.useState(false);
    const [activeSendForm, setActiveSendForm] = React.useState(false);
    const [loadingConsesionarias, setLoadingConsesionarias] = React.useState(true);
    const [showErrorConsesionarias, setShowErrorConsesionarias] = React.useState(false);
    //const [horariosDisponiblesEncontrados, setHorariosDisponiblesEncontrados] = React.useState(true);


    /**
     * Meses y días en español para Datepicker
     */
    const days = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá']
    const months = ['Enero de', 'Febrero de', 'Marzo de', 'Abril de', 'Mayo de', 'Junio de', 'Julio de', 'Agosto de', 'Septiembre de', 'Octubre de', 'Noviembre de', 'Diciembre de']

    const localeCustomDate = {
        localize: {
            day: n => days[n],
            month: n => months[n]
        },
        formatLong: {
            date: () => 'yyyy-mm-dd'
        }
    }

    const [tratamiento, setTratamiento] = useState("Sr");
    const setNombre = (inNombre) => { dispatch(setNombreAction(isOnlyCharacters(inNombre))); }
    const setApellidoPaterno = (inApellidoPaterno) => { dispatch(setApellidoPaternoAction(isOnlyCharacters(inApellidoPaterno))); }
    const setApellidoMaterno = (inApellidoMaterno) => { dispatch(setApellidoMaternoAction(isOnlyCharacters(inApellidoMaterno))); }
    const setEstado = (inEstado, listConcesionarios) => {
        dispatch(setEstadoAction(inEstado));
        setfilterDealers(listConcesionarios.filter(function (el) {
            return el.stateName === inEstado
        }));
    }
    const setConcesionario = (inConcesionario) => {
        dispatch(setIdConcesionarioAction(inConcesionario.value));
        dispatch(setConcesionarioAction(inConcesionario.options[inConcesionario.selectedIndex].text));

        let dealerEncontrado = citasServiciosObj.listConcesionarios.filter(function (el) {
            return el.dealerNumber === parseInt(inConcesionario.value)
        })[0];
        let correoEncontrado = dealerEncontrado.contactos !== null ? dealerEncontrado.contactos.split(",").length > 8 ? dealerEncontrado.contactos.split(",")[8].split(";").map(item => item.trim()) : "" : "";
        let linkPrivacidad = dealerEncontrado.contactos !== null ? dealerEncontrado.contactos.split(",").length > 8 ? dealerEncontrado.contactos.split(",")[4].split(";").map(item => item.trim()) : "" : "";

        dispatch(setCorreoContactoAction(correoEncontrado));
        dispatch(setDealersUrlsAction(linkPrivacidad));

        getHorarios(inConcesionario.value, citasServiciosObj.servicio, citasServiciosObj.fechaCita, citasServiciosObj.uuid)
    }
    const setTelefono = (inTelefono) => { dispatch(setTelefonoAction(isOnlyNumbers(inTelefono))); setvalidPhone(isValidPhone(inTelefono)) }
    const setCorreo = (inCorreo) => { setvalidEmail(isValidEmail(inCorreo)); dispatch(setCorreoAction(inCorreo)); }
    const setFechaCita = (inFechaCita) => {
        setStartDate(inFechaCita);
        dispatch(setFechaCitaAction(inFechaCita.toISOString().substring(0, 10)));
        getHorarios(citasServiciosObj.idConcesionario, citasServiciosObj.servicio, inFechaCita.toISOString().substring(0, 10), citasServiciosObj.uuid)
    }
    const setHorario = (inHorario) => { dispatch(setHorarioAction(inHorario)); }
    const setModeloAuto = (inModeloAuto) => { dispatch(setModeloAutoAction(inModeloAuto)); }
    const setYearModelo = (inYearAuto) => { dispatch(setYearAutoAction(inYearAuto)); }
    const setServicio = (inServicio) => {
        dispatch(setServicioAction(inServicio));
        getHorarios(citasServiciosObj.idConcesionario, inServicio, citasServiciosObj.fechaCita, citasServiciosObj.uuid);
    }
    const setComentarios = (inComentarios) => { dispatch(setComentariosAction(inComentarios)); }
    const setAvisoPrivacidad = (inAvisoPrivacidad) => { dispatch(setAvisoPrivacidadAction(inAvisoPrivacidad)); }
    //const setTerminos = ( inTerminos ) => {dispatch(setTerminosAction(inTerminos));}

    const isWeekday = (date) => {
        const day = date.getDay();
        return day !== 0; //&& day !== 6;
    };


    const verifyHour = (horaValor) => {
        let yourDate = new Date()
        let fechaHoyCompare = yourDate.toISOString().split('T')[0];

        if (citasServiciosObj.fechaCita === fechaHoyCompare) {
            var time = new Date();
            var horaHorario = horaValor.split(":"),
                t1 = new Date(),
                t2 = new Date();

            t1.setHours(time.getHours(), time.getMinutes(), time.getSeconds());
            t2.setHours(horaHorario[0], horaHorario[1], "00");

            //console.log(t2.getHours()+":"+("0" + t2.getMinutes()).slice(-2)+" - "+ ("0" + t1.getHours()).slice(-2)+":"+("0" + t1.getMinutes()).slice(-2)+" = "+(parseInt(t2.getHours().toString()+("0" + t2.getMinutes()).slice(-2).toString()) - parseInt(("0" + t1.getHours()).slice(-2).toString()+("0" + t1.getMinutes()).slice(-2).toString())))

            if (parseInt(t2.getHours().toString() + ("0" + t2.getMinutes()).slice(-2).toString()) - parseInt(("0" + t1.getHours()).slice(-2).toString() + ("0" + t1.getMinutes()).slice(-2).toString()) <= 300) {//<= 300 ) {
                //console.log("ENTRADA 11111111111")
                //horariosDisponiblesEncontrados === true && setHorariosDisponiblesEncontrados(false);
                return false;
            } else {
                //console.log("ENTRADA 22222222222")
                //horariosDisponiblesEncontrados === false && setHorariosDisponiblesEncontrados(true);
                return true;
            }
        } else {
            //console.log("ENTRADA 3333333333")
            //horariosDisponiblesEncontrados === false && setHorariosDisponiblesEncontrados(true);
            return true;
        }
    }

    const getHorarios = (idConcesionario, servicio, fechaCita, uuid) => {

        if (idConcesionario !== "" && servicio !== "" && fechaCita !== "" && uuid !== "") {
            //console.log("BUSCA HORARIOOOOOOOOOOOS")
            dispatch(setListFechasHorariosAction(uuid, fechaCita, fechaCita, servicio, idConcesionario, citasServiciosObj.horariosDealerOffline));
            //setHorariosDisponiblesEncontrados(true);
            //getHorarios2();
        }
        //dispatch(setListFechasHorariosAction("da2f3fb5-730f-455b-8dbd-1808ad6d8eef","2022-12-15","2022-12-31","Servicio de Mantenimiento","3603"));
    }

    const sendForm = () => {
        // sendMailConCita(citasServiciosObj);
        // sendMailSinCita(citasServiciosObj);
        setActiveSendForm(true);


        if (citasServiciosObj.errorConsultarHorarios) {
            sendMailSinCita(citasServiciosObj);
            sendMailDealer(citasServiciosObj);
            redirigirThankYouPage();
        } else {
            solicitarCita(citasServiciosObj)
                .then((response) => {
                    //console.log(response);

                    if (response.data.data === null
                        || (response.data.data.hasOwnProperty('message') && response.data.data.message === "Endpoint request time out")
                        || (response.data.data.hasOwnProperty('errorCode') && response.data.data.hasOwnProperty('title'))) {
                        //Error de servicio
                        setErrorFormStatus(false);
                        setActiveSendForm(false);
                        sendMailSinCita(citasServiciosObj);
                        sendMailDealer(citasServiciosObj);
                        redirigirThankYouPage();
                    } else if (response.data.data.hasOwnProperty('idCita')) {
                        sendMailConCita(citasServiciosObj, response.data.data.idCita);
                        setErrorFormStatus(false);
                        setActiveSendForm(false);

                        if (ReactGA.isInitialized) {
                            ReactGA.event('lead_sended', {
                                category: "Citas de servicio",
                                action: "Lead enviado exitosamente",
                                label: "Nuevo Lead Cita de servicio", // optional
                                once: true // Solo se envia una vez
                            });
                        }

                        redirigirThankYouPage();
                    } else {
                        //Error de servicio
                        console.log(response.data.data)
                        setErrorFormStatus(false);
                        setActiveSendForm(false);
                        sendMailSinCita(citasServiciosObj);
                        sendMailDealer(citasServiciosObj);
                        redirigirThankYouPage();
                    }
                })
                .catch((errorMessageSolicitarCitar) => {
                    //Error de servicio
                    setErrorFormStatus(false);
                    setActiveSendForm(false);
                    sendMailSinCita(citasServiciosObj);
                    sendMailDealer(citasServiciosObj);
                    redirigirThankYouPage();
                });

        }

    }

    const redirigirThankYouPage = () => {
        if (concesionaria === undefined || concesionaria === null || concesionaria === "") {
            navigate(ROUTES.CITASSERVICIOTHANKYOUEMPTY);
        } else {
            navigate(ROUTES.CITASSERVICIOTHANKYOUEMPTY + "/" + concesionaria);
        }
    }

    useEffect(() => {
        if (process.env.REACT_APP_ENABLE_GA4 === "true") {
            // Se inicializa el objeto de analytics para el sitio
            ReactGA.initialize(process.env.REACT_APP_CITAS_SERVICIO_GA_ID);
        }

        if (concesionaria !== undefined) {
            document.title = "Citas de servicio - " + concesionaria;
        } else {
            document.title = "Citas de servicio - General";
            // ({ hitType: "pageview", page: "/citas-de-servicio/agendar", title: "Citas de servicio - General"});
        }

        dispatch(setListEstadosAction());

        getConcesionarios()
            .then((responseConcesionarios) => {
                dispatch(setListConcesionariosAction(responseConcesionarios.data.data.filter(function (el) {
                    return el.name.includes("Audi Center")
                })));
                setfilterDealers(responseConcesionarios.data.data.filter(function (el) {
                    return el.name.includes("Audi Center")
                }));

                if (concesionaria !== undefined) {
                    // ({ hitType: "pageview", page: "/citas-de-servicio/agendar", title: "Citas de servicio - " + concesionaria });
                    //console.log("Listado de conce")
                    let dealerActualPage = responseConcesionarios.data.data.filter(function (el) {
                        return el.dealerNumber === parseInt(concesionaria)
                    })[0];

                    //console.log(dealerActualPage)
                    //console.log(dealerActualPage.contactos)

                    dispatch(setEstadoAction(dealerActualPage.stateName));
                    dispatch(setIdConcesionarioAction(dealerActualPage.dealerNumber.toString()));
                    dispatch(setConcesionarioAction(dealerActualPage.name));
                    dispatch(setHorariosDealerOfflineAction(dealerActualPage.schedules.replace(/ /g, '').split(",")));

                    if (dealerActualPage.contactos !== null) {
                        //console.log("Sedivide")
                        //console.log(dealerActualPage.contactos.split(","))
                        //console.log(dealerActualPage.contactos.split(",")[8])
                        let correoEncontrado = dealerActualPage.contactos.split(",").length > 8 ? dealerActualPage.contactos.split(",")[8].split(";").map(item => item.trim()) : "";
                        let linkPrivacidad = dealerActualPage.contactos.split(",").length > 8 ? dealerActualPage.contactos.split(",")[4].split(";").map(item => item.trim()) : "";

                        //console.log(correoEncontrado)  pruebaCitas.split(",")[8].split(";").map(item => item.trim())
                        dispatch(setCorreoContactoAction(correoEncontrado));
                        dispatch(setDealersUrlsAction(linkPrivacidad));
                    }
                }
                setLoadingConsesionarias(false)

                //dispatch(setEstadoAction(inEstado));
                //dispatch(setIdConcesionarioAction(inConcesionario.value));
                //dispatch(setConcesionarioAction(inConcesionario.options[inConcesionario.selectedIndex].text));
            }).catch((error) => {
                console.log(error);
                setShowErrorConsesionarias(true);
            })
        //dispatch(setListConcesionariosAction(audiCentersList));
        //setfilterDealers(audiCentersList)

        /*if(concesionaria !== undefined || concesionaria !== null || concesionaria !== ""){
            dispatch(setIdConcesionarioAction(concesionaria));
        }*/

        dispatch(setUuidAction(uuid()));
        dispatch(setListModelosAction(dataModelos));
    }, [concesionaria, dispatch]);

    if (showErrorConsesionarias) return <section>
        <div className="loading-g d-vertical-center loading-btn" style={{ marginTop: "100px" }}>
            <div>
                <span> Lamentamos los inconvenientes con nuestro servicio, inténtelo de nuevo más tarde. </span>
            </div>
        </div>
    </section>

    return (
        <>
            <IFrameResize IFrameHeight={1900} url={window.location.pathname} />
            <div className="container citas-servicio">
                <div className="row">
                    <div className="col-12 text-center mt-5 d-none">
                        <h2>Citas de servicio</h2>
                        <p>
                            En Audi Service contamos con asesores de servicio, técnicos altamente capacitados y personal calificado <br />
                            Te invitamos a agendar una cita de servicio o si ya cuentas con una cita consulta tu historial.
                        </p>
                    </div>

                    <span className="fg-title mb-4 mb-md-5 mt-5">1. Ingresa tus datos</span>
                    <TratoComponent value={tratamiento} onChange={(e) => { setTratamiento(e.target.value) }} />

                    <div className="col-12 col-md-6 mb-4 mb-md-5">
                        <input
                            className="cs-input"
                            id="name"
                            placeholder="Nombre"
                            type="text"
                            value={citasServiciosObj.nombre}
                            onChange={(e) => setNombre(e.target.value)}
                        />
                    </div>
                    <div className="col-md-6"></div>
                    <div className="col-12 col-md-6 mb-4 mb-md-5">
                        <input
                            className="cs-input"
                            id="apellidoPaterno"
                            placeholder="Apellido Paterno"
                            type="text"
                            value={citasServiciosObj.apellidoPaterno}
                            onChange={(e) => setApellidoPaterno(e.target.value)}
                        />
                    </div>
                    <div className="col-12 col-md-6 mb-4 mb-md-5">
                        <input
                            className="cs-input"
                            id="apellidoMaterno"
                            placeholder="Apellido Materno"
                            type="text"
                            value={citasServiciosObj.apellidoMaterno}
                            onChange={(e) => setApellidoMaterno(e.target.value)}
                        />
                    </div>

                    {
                        (concesionaria === undefined || concesionaria === null || concesionaria === "") &&
                        <>
                            <div className="col-12 col-md-6 mb-4 mb-md-5">
                                <select
                                    className="form-select cs-input in-select"
                                    id="estado"
                                    defaultValue={citasServiciosObj.estado}
                                    onChange={(e) => setEstado(e.target.value, citasServiciosObj.listConcesionarios)}
                                    disabled={citasServiciosObj.buscaFechasLoading}
                                >
                                    <option className="d-none" value="">Estado</option>
                                    {
                                        citasServiciosObj.listEstados.map((item, i) =>
                                            <option value={item.nombreedo} key={"estados_opt_" + i}>{item.nombreedo}</option>
                                        )
                                    }
                                </select>
                            </div>
                            <div className="col-12 col-md-6 mb-4 mb-md-5">
                                <select
                                    className="form-select cs-input in-select"
                                    id="concesionario"
                                    defaultValue={citasServiciosObj.idConcesionario}
                                    onChange={(e) => setConcesionario(e.target)}
                                    disabled={citasServiciosObj.buscaFechasLoading}
                                >
                                    <option className="d-none" value="">Concesionario</option>
                                    {
                                        citasServiciosObj.estado !== "" &&
                                        filterDealers.map((item, i) =>
                                            <option value={item.dealerNumber} key={"concesionarios_opt_" + i}>{item.name}</option>
                                        )
                                    }
                                </select>
                            </div>
                        </>
                    }

                    <div className="col-12 col-md-6 mb-4 mb-md-5">
                        <input
                            className="cs-input"
                            id="telefono"
                            placeholder="Télefono"
                            type="text"
                            maxLength={10}
                            value={citasServiciosObj.telefono}
                            onChange={(e) => setTelefono(e.target.value)}
                        />
                        {
                            !validPhone && citasServiciosObj.telefono !== "" &&
                            <span className="inValid-input">
                                Introduzca un número de teléfono válido, ya sea fijo o móvil a 10 dígitos.
                            </span>
                        }
                    </div>
                    <div className="col-12 col-md-6 mb-4 mb-md-5">
                        <input
                            className="cs-input"
                            id="correo"
                            placeholder="Correo electrónico"
                            type="text"
                            value={citasServiciosObj.correo}
                            onChange={(e) => setCorreo(e.target.value)}
                        />
                        {
                            !validEmail && citasServiciosObj.correo !== "" && <span className="inValid-input">Use un e-mail válido con formato: nombre@dominio.com</span>
                        }
                    </div>

                    <span className="fg-title mb-4 mb-md-5 mt-4">
                        2. Ingresa el día, horario y servicio de interés
                        <div className="fg-title-tooltip ms-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="17.822" height="17.822" viewBox="0 0 17.822 17.822">
                                <g id="Grupo_121" data-name="Grupo 121" transform="translate(-1474.303 -1170.089)">
                                    <path id="time-small" d="M17.822,10.161A8.661,8.661,0,1,1,9.161,1.5,8.636,8.636,0,0,1,17.822,10.161Z" transform="translate(1474.053 1168.839)" fill="none" stroke="#000" strokeWidth="0.5" fillRule="evenodd" />
                                    <path id="Trazado_2226" data-name="Trazado 2226" d="M3563.214-7786.665v5.765h3.813" transform="translate(-2080 8960)" fill="none" stroke="#000" strokeWidth="0.5" />
                                </g>
                            </svg>
                            <span className="fg-title-tooltiptext">Los horarios y fechas reflejados se encuentran disponibles en la concesionaria que elegiste.</span>
                        </div>
                    </span>


                    <div className="col-12 col-md-6 mb-4 mb-md-5">
                        <select
                            className="fform-select cs-input in-select"
                            id="servicio"
                            defaultValue={citasServiciosObj.servicio}
                            onChange={(e) => setServicio(e.target.value)}
                            disabled={citasServiciosObj.buscaFechasLoading}
                        >
                            <option className="d-none" value="">Servicio de interés</option>
                            <option value="Reparación General">Reparación General</option>
                            <option value="Servicio de Mantenimiento">Servicio de Mantenimiento</option>
                            <option value="Taller de hojalatería y pintura">Taller de hojalatería y pintura</option>
                        </select>
                    </div>

                    <div className="col-12 col-md-6 mb-4 mb-md-5">
                    </div>

                    <div className="col-12 col-md-6 mb-4 mb-md-5">
                        {
                            //<input className="cs-input" id="name" value="" placeholder="Fecha" type="text" />
                            <DatePicker
                                className="cs-input in-date"
                                //selected={startDate} 
                                locale={localeCustomDate}
                                selected={startDate}
                                value={citasServiciosObj.fechaCita === "" ? "Fecha" : startDate}
                                minDate={todayDate}
                                filterDate={isWeekday}
                                dateFormat="dd / MM / yyyy"
                                onChange={(date) => setFechaCita(date)}
                                disabled={citasServiciosObj.buscaFechasLoading}
                            />
                        }
                    </div>


                    <div className="col-12 col-md-6 mb-4 mb-md-5">
                        {
                            loadingConsesionarias || citasServiciosObj.buscaFechasLoading
                                ? <div className="loading-g d-vertical-center loading-btn">
                                    <div>
                                        <ReactLoading type="cylon" color="#000" width={'100%'} height={'58px'} />
                                        <span> {loadingConsesionarias ? "Obteniendo datos del concesionario" : "Buscando horarios"}</span>
                                    </div>
                                </div>
                                : <>
                                    <select
                                        className="form-select cs-input in-select in-select-time"
                                        id="horario"
                                        defaultValue={citasServiciosObj.horarioCita}
                                        onChange={(e) => setHorario(e.target.value)}
                                    >
                                        <option className="d-none" value="">Horario</option>
                                        <option className="d-none" value="" disabled>No hay horarios disponibles, inténtalo de nuevo</option>
                                        {
                                            //!citasServiciosObj.errorConsultarHorarios &&
                                            citasServiciosObj.listFechasHorarios.hasOwnProperty('horariosAtencion') && citasServiciosObj.listFechasHorarios.horariosAtencion.hasOwnProperty(citasServiciosObj.fechaCita) &&

                                            [citasServiciosObj.fechaCita].map(e => citasServiciosObj.listFechasHorarios.horariosAtencion[e]).flat().map((item, i) =>
                                                Object.keys(item).map((item, i) => (
                                                    verifyHour(item) &&
                                                    <option value={item} key={"horarios_ser_" + i}>{item}</option>
                                                ))
                                            )
                                        }
                                    </select>

                                    <span className="inValid-input">
                                        {citasServiciosObj.idConcesionario === ""
                                            ? "Seleccione una concesionaria"
                                            : citasServiciosObj.servicio === ""
                                                ? "Seleccione un servicio de interés"
                                                : citasServiciosObj.fechaCita === ""
                                                    ? "Seleccione un fecha"
                                                    : citasServiciosObj.listFechasHorarios === null
                                                        ? ""//"No hubo respuesta en el servicio. Puede continuar sin seleccionar un horario y se enviara un correo donde un asesor lo contactara para buscarle una cita."
                                                        : Object.keys(citasServiciosObj.listFechasHorarios).length === 0
                                                            ? "No hay horarios disponibles, inténtalo de nuevo o seleccione otra fecha"
                                                            : citasServiciosObj.listFechasHorarios.hasOwnProperty('message')
                                                                ? citasServiciosObj.listFechasHorarios.message === "Endpoint request time out"
                                                                && ""//"No hubo respuesta en el servicio. Puede continuar sin seleccionar un horario y se enviara un correo donde un asesor lo contactara para buscarle una cita."
                                                                : citasServiciosObj.listFechasHorarios.hasOwnProperty('errorCode')
                                                                    && citasServiciosObj.listFechasHorarios.hasOwnProperty('title')
                                                                    ? ""//citasServiciosObj.listFechasHorarios.title + " Puede continuar sin seleccionar un horario y se enviara un correo donde un asesor lo contactara para buscarle una cita."
                                                                    : Object.keys(citasServiciosObj.listFechasHorarios).length > 0
                                                                    && citasServiciosObj.errorConsultarHorarios
                                                                    && ""//"No hubo respuesta en el servicio. Puede continuar seleccionando un horario y se enviara un correo donde un asesor lo contactara para buscarle una cita."
                                        }
                                    </span>

                                </>

                        }

                    </div>

                    <span className="fg-title mt-4 mb-4 mb-md-5">3. Ingresa el modelo y año de tu vehículo</span>

                    <div className="col-12 col-md-6 mb-4 mb-md-5">
                        <select
                            className="form-select cs-input in-select"
                            id="modeloAuto"
                            defaultValue={citasServiciosObj.modeloAuto}
                            onChange={(e) => setModeloAuto(e.target.value)}
                        >
                            <option className="d-none" value="">Modelo de tu auto</option>
                            {
                                citasServiciosObj.listModelos.map((item, i) =>
                                    <option value={item.model} key={"modelos_opt_" + i}>{item.model}</option>
                                )
                            }
                        </select>
                    </div>
                    <div className="col-12 col-md-6 mb-4 mb-md-5">
                        <select
                            className="form-select cs-input in-select"
                            id="yearAuto"
                            defaultValue={citasServiciosObj.yearModelo}
                            onChange={(e) => setYearModelo(e.target.value)}
                        >
                            <option className="d-none" value="">Año de tu auto</option>
                            <option value="2011">2011</option>
                            <option value="2012">2012</option>
                            <option value="2013">2013</option>
                            <option value="2014">2014</option>
                            <option value="2015">2015</option>
                            <option value="2016">2016</option>
                            <option value="2017">2017</option>
                            <option value="2018">2018</option>
                            <option value="2019">2019</option>
                            <option value="2020">2020</option>
                            <option value="2021">2021</option>
                            <option value="2022">2022</option>
                            <option value="2023">2023</option>
                            <option value="2024">2024</option>
                        </select>
                    </div>

                    <div className="col-12 col-md-7 mb-2 mb-md-3">
                        <textarea
                            className="form-control cs-input in-textarea"
                            id="comentarios"
                            rows="5"
                            maxLength="1000"
                            placeholder="Comentarios"
                            value={citasServiciosObj.comentarios}
                            onChange={(e) => setComentarios(e.target.value)}
                        >
                        </textarea>
                    </div>

                    <span className="fg-note mb-3 mb-md-5">Max. 1.000 caracteres</span>

                    <span className="fg-subtitle  mt-3 mb-4 mb-md-5">Declaraciones de conformidad relativas a la protección de datos</span>
                    <div className="col-12 col-md-7 mb-4 mb-md-5">
                        <p>Para poder ofrecerle de ahora en adelante el mejor asesoramiento posible y para poder enviarle información sobre nuevos productos y servicios necesitamos su consentimiento.</p>
                    </div>

                    <div className="col-12 mb-4 mb-md-5">
                        <input
                            className="in_checkbox"
                            id="avisoPrivacidad"
                            type="checkbox"
                            checked={citasServiciosObj.avisoPrivacidad}
                            onChange={() => setAvisoPrivacidad(!citasServiciosObj.avisoPrivacidad)}
                        />
                        <label htmlFor="avisoPrivacidad">He leído y acepto el <a href={citasServiciosObj.dealerUrls.length === 0 ? process.env.REACT_APP_AVISO_PRIVACIDAD : citasServiciosObj.dealerUrls[1]} target="_blank" rel="noreferrer">Aviso de Privacidad.</a></label>
                    </div>

                    {
                        /*<div className="col-12 mb-4 mb-md-5">
                            <input 
                                className="in_checkbox" 
                                id="terminos" 
                                type="checkbox" 
                                checked={citasServiciosObj.terminosCondiciones} 
                                onChange={() =>setTerminos(!citasServiciosObj.terminosCondiciones)}
                            />
                            <label htmlFor="terminos">He leído y acepto los <a href={process.env.REACT_APP_TERMINOS_CONDICIONES} target="_blank" rel="noreferrer">Términos y Condiciones.</a></label>
                        </div>*/
                    }



                    <div className="col-12">
                        {
                            !activeSendForm
                                ? !citasServiciosObj.errorConsultarHorarios
                                    ? citasServiciosObj.nombre !== ""
                                        && citasServiciosObj.apellidoPaterno !== ""
                                        && citasServiciosObj.apellidoMaterno !== ""
                                        && citasServiciosObj.estado !== ""
                                        && citasServiciosObj.idConcesionario !== ""
                                        && citasServiciosObj.concesionario !== ""
                                        && citasServiciosObj.telefono !== ""
                                        && validPhone
                                        && citasServiciosObj.correo !== ""
                                        && validEmail
                                        && citasServiciosObj.servicio !== ""
                                        && citasServiciosObj.fechaCita !== ""
                                        && citasServiciosObj.horarioCita !== ""
                                        && citasServiciosObj.modeloAuto !== ""
                                        && citasServiciosObj.yearModelo !== ""
                                        //&& citasServiciosObj.comentarios !== ""
                                        && citasServiciosObj.avisoPrivacidad === true
                                        //&& citasServiciosObj.terminosCondiciones === true
                                        ? <button
                                            className="button-enviar"
                                            onClick={() => sendForm()}
                                            disabled={false}
                                        >
                                            Enviar
                                        </button>
                                        : <button
                                            className="button-enviar disabled"
                                            //onClick={() => sendForm()}
                                            disabled={true}
                                        >
                                            Enviar
                                        </button>
                                    : citasServiciosObj.nombre !== ""
                                        && citasServiciosObj.apellidoPaterno !== ""
                                        && citasServiciosObj.apellidoMaterno !== ""
                                        && citasServiciosObj.estado !== ""
                                        && citasServiciosObj.idConcesionario !== ""
                                        && citasServiciosObj.concesionario !== ""
                                        && citasServiciosObj.telefono !== ""
                                        && validPhone
                                        && citasServiciosObj.correo !== ""
                                        && validEmail
                                        && citasServiciosObj.servicio !== ""
                                        && citasServiciosObj.fechaCita !== ""
                                        && citasServiciosObj.horarioCita !== ""
                                        && citasServiciosObj.modeloAuto !== ""
                                        && citasServiciosObj.yearModelo !== ""
                                        //&& citasServiciosObj.comentarios !== ""
                                        && citasServiciosObj.avisoPrivacidad === true
                                        //&& citasServiciosObj.terminosCondiciones === true
                                        ? <button
                                            className="button-enviar"
                                            onClick={() => sendForm()}
                                            disabled={false}
                                        >
                                            Enviar
                                        </button>
                                        : <button
                                            className="button-enviar disabled"
                                            //onClick={() => sendForm()}
                                            disabled={true}
                                        >
                                            Enviar
                                        </button>
                                : <button
                                    className="button-enviar disabled"
                                    //onClick={() => sendForm()}
                                    disabled={true}
                                >
                                    <div className="loading-g loading-send loading-btn">
                                        <div>
                                            <ReactLoading type="cylon" color="#fff" width={'100%'} height={'58px'} />
                                        </div>
                                    </div>
                                </button>
                        }



                    </div>

                    <span className="inValid-input">
                        {
                            errorFormStatus
                                ? "ERROR - No se pudo envíar el formulario."
                                : ""
                        }
                    </span>



                    <div className="col-12 mb-5"></div>

                </div>
            </div>
        </>
    );
};

export default CitasServicio;